export const statusLabels = {
  inquiry: 'Inquiry',
  proposal: 'Proposal',
  negotiation: 'Negotiation',
  active: 'Ready',
  in_progress: 'In Progress',
  in_review: 'In Review',
  review: 'In Review',
  completed: 'Completed',
  on_hold: 'On Hold',
  archived: 'Archived',
  cancelled: 'Cancelled',
};

// Normalize status so that any non-primary statuses are treated as 'active' for display
export function normalizeStatus(status) {
  const allowed = new Set([
    'active',
    'in_progress',
    'in_review',
    'completed',
    'on_hold',
    'archived',
    'canceled',
    'cancelled'
  ]);
  return allowed.has(status) ? status : 'active';
}

export function getStatusLabel(status) {
  if (!status) return '';
  const s = normalizeStatus(status);
  return statusLabels[s] || s.replace(/_/g, ' ');
}

export function getStatusBadgeClass(status) {
  const s = normalizeStatus(status);
  switch (s) {
    case 'completed':
      return 'badge-success';
    case 'active':
    case 'in_progress':
      return 'badge-primary';
    case 'in_review':
    case 'review':
    case 'on_hold':
      return 'badge-warning';
    case 'cancelled':
    case 'canceled':
      return 'badge-danger';
    default:
      return 'badge-secondary';
  }
}

export default { statusLabels, normalizeStatus, getStatusLabel, getStatusBadgeClass };